// Project-wide constants — server URL, topic name, IDB name, sync tuning
// @work.md

// Base URL for the cmstr server
export const CMSTR_URL = "https://cs.rho.ie";

// Topic name for bookmarks in cmstr
export const BOOKMARKS_TOPIC = "bookmark";

// IDB database name for the cmstr IDBBackend
export const CMSTR_IDB_NAME = "cmstr-bkmk";

// How often to poll the server for new events while the tab is open.
export const POLL_INTERVAL_MS = 60_000;

// How long each sync tails the remote event stream after fetching. The remote stream never
// ends by itself, so any non-zero value blocks the sync for its full duration. Zero: the
// poll above picks up writes that land during a sync.
export const TAIL_DURATION_MS = 0;
